import React, { useCallback, useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { useTheme } from '@material-ui/core/styles';
import { Drawer, IconButton, Portal, useMediaQuery } from '@material-ui/core';
import { Menu } from '@material-ui/icons';
import { IReactProps } from 'types';
import useStyles from './style';

const findMenuPortal = () => document.getElementById('menu-portal');

function MenuContainer({ children }: IReactProps) {
  const classes = useStyles();
  const location = useLocation();
  const theme = useTheme();
  const [open, setOpen] = useState(false);
  const largeScreen = useMediaQuery(theme.breakpoints.up('md'));

  const handleToggle = useCallback(() => setOpen(!open), [open]);

  useEffect(() => setOpen(false), [location]);

  if (largeScreen) {
    return <React.Fragment>{children}</React.Fragment>;
  }

  return (
    <React.Fragment>
      <Portal container={findMenuPortal}>
        <IconButton
          className={classes.menuButton}
          color="inherit"
          edge="start"
          onClick={handleToggle}
        >
          <Menu />
        </IconButton>
      </Portal>
      <Drawer
        PaperProps={{ className: classes.drawer }}
        anchor="left"
        className={classes.drawer}
        open={open}
        variant="temporary"
        onClose={handleToggle}
      >
        {children}
      </Drawer>
    </React.Fragment>
  );
}

export default React.memo(MenuContainer);
